<div class="apg-loading" *ngIf="loading">
  <p>{{message}}</p>
  <ion-spinner></ion-spinner>
</div>

<div *ngIf="!loading">
  <app-site-content key="BankDetails.Confirm" [appScrollIntoView]="true">
  </app-site-content>

  <app-questionnaire-summary hideTitle="true">
    <app-summary-row label="Account holder's name">
      {{answers["DirectDebitAccountHolderName"]}}
    </app-summary-row>
    <app-summary-row label="Account number">
      {{answers["DirectDebitAccountNumber"]}}
    </app-summary-row>
    <app-summary-row label="Sort code">
      {{answers["DirectDebitSortCode"]}}
    </app-summary-row>
    <app-summary-row label="Premium amount">
      {{answers["MagnumPremium"] | currency:'GBP':'symbol':'1.2-2'}}
    </app-summary-row>
    <app-summary-row label="Monthly collection day">
      {{answers["DirectDebitDay"]}}
    </app-summary-row>
    <app-summary-row label="Policy start date">
      {{answers["DirectDebitPolicyStartDate"]}}
    </app-summary-row>
  </app-questionnaire-summary>

  <div class="confirm-personal">
    <ion-checkbox [disabled]="true" checked="true"></ion-checkbox>
    <app-site-content type="label" key="BankDetails.DirectDebitConfirm">
    </app-site-content>
  </div>

  <app-site-content class="valid-msg" *ngIf="result?.valid" key="BankDetails.Valid">
  </app-site-content>

  <app-site-content class="valid-msg" *ngIf="result?.error" [showTitle]="false" [key]="result.error">
  </app-site-content>

  <div class="summary__buttons">
    <ion-button (click)="back.emit()">
      <ion-icon name="chevron-back-outline"></ion-icon>
      Back
    </ion-button>

    <ion-button *ngIf="!result" (click)="verify()">
      Verify
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>

    <ion-button *ngIf="result" [disabled]="!result.valid" (click)="continue.emit(result)">
      Buy Policy
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>

</div>